import { PROJECTS_REQUEST, PROJECTS_SUCCESS, PROJECTS_FAILURE, PROJECT_EDIT_PAGE_REQUEST, PROJECT_EDIT_PAGE_SUCCESS, PROJECT_DELETE_CONFIRM, PROJECT_DELETE_CONFIRM_DECLINE, PROJECT_DELETE_FAILURE, PROJECT_DELETE_SUCCESS } from "../../redux/action_constant";
import { ProjectActions, ProjectInterface, ProjectState } from "./ProjectTypes";


const initialState: ProjectState = {
    pending: false,
    error: null,
    loading: false,
    projectList: [] as ProjectInterface[],
    next_offset: 0,
    listCount: 0,
    editProject: {} as ProjectInterface,
    showDeleteModal: false,
    deleteProject: {} as ProjectInterface,
};

const ProjectReducer = (state = initialState, action: ProjectActions) => {
    switch (action.type) {
        case PROJECTS_REQUEST:
            return {
                ...state,
                loading: true,
                editProject: {} as ProjectInterface,
                showDeleteModal: false,
                deleteProject: {} as ProjectInterface,
            };
        case PROJECTS_SUCCESS:
            return {
                ...state,
                loading: false,
                projectList: action.payload.list,
                next_offset: action.payload.next_offset,
                listCount: action.payload.count,
                error: null,
            };
        case PROJECTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                projectList: [],
                next_offset: -1,
                listCount: 0,
            };
        case PROJECT_EDIT_PAGE_SUCCESS:
            return {
                ...state,
                editProject: action.payload,
            };
        case PROJECT_DELETE_CONFIRM:
            return {
                ...state,
                showDeleteModal: true,
                deleteProject: action.payload,
            };
        case PROJECT_DELETE_CONFIRM_DECLINE:
            return {
                ...state,
                showDeleteModal: false,
                deleteProject: {} as ProjectInterface,
            };
        case PROJECT_DELETE_FAILURE:
            return {
                ...state,
                showDeleteModal: false,
                deleteProject: {} as ProjectInterface,
            };
        case PROJECT_DELETE_SUCCESS:
            return {
                ...state,
                showDeleteModal: false,
                deleteProject: {} as ProjectInterface,
            };
        default:
            return {
                ...state,
            };
    }
};

export default ProjectReducer;   